import { Component, Input, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'tog-fake-ui-loader',
  templateUrl: './fake-ui-loader.component.html',
  styleUrls: ['./fake-ui-loader.component.scss']
})
export class FakeUiLoaderComponent implements OnInit {
  @Input() listLength: number = 10;

  applicationMode: boolean = false;
  dashboardMode: boolean = false;
  simpleMode: boolean = false;
  podOrPromotion: boolean = false;
  togTable: boolean = false;
  repeatableArray: any[] = [];

  constructor(private _el: ElementRef) {
    if (this._el.nativeElement.classList.contains('pod') ||
        this._el.nativeElement.classList.contains('promotion')) {
      this.podOrPromotion = true;
      if (this.listLength === 10) this.listLength = 6;
    } else if (this._el.nativeElement.classList.contains('simple')) {
      this.simpleMode = true;
    } else if (this._el.nativeElement.classList.contains('app')) {
      this.applicationMode = true;
    } else if (this._el.nativeElement.classList.contains('dashboard')) {
      this.dashboardMode = true;
    } else if (this._el.nativeElement.classList.contains('tog-table')) {
      this.togTable = true;
    }
    this.repeatableArray = Array(this.listLength).fill('');
  }

  ngOnInit() {
    if (!this.podOrPromotion && !this.simpleMode && !this.togTable) this.generateTableElements();
    if (!this.podOrPromotion && !this.simpleMode && this.togTable) this.generateTogTableElements();
  }

  generateTableElements() {
    let tds = this._el.nativeElement.getElementsByTagName('td');
    setTimeout(() => {
      if (tds.length) {
        for (let i = 0; i < tds.length; i++) {
          let b = document.createElement('div');
          b.classList.add('gradient');
          tds[i].appendChild(b);
        }
      }
      let tr: HTMLElement[] = this._el.nativeElement.getElementsByTagName('tr');
      let tbody: HTMLElement = this._el.nativeElement.getElementsByTagName('tbody')[0];
      if (tr.length) {
        for (let i = 1; i < this.listLength; i++) {
          let clone = tr[0].cloneNode(true);
          tbody.appendChild(clone);
        }
      }
    }, 0);
  }

  generateTogTableElements() {
    setTimeout(() => {
      let cells: HTMLCollection = this._el.nativeElement.getElementsByTagName('tog-table-cell');
      for (let i = 0; i < cells.length; i++) {
        let b = document.createElement('div');
        b.classList.add('gradient');
        cells[i].appendChild(b);
      }
      let row: HTMLElement = this._el.nativeElement.getElementsByTagName('tog-table-row')[0];
      for (let i = 1; i < this.listLength; i++) {
        let clone = row.cloneNode(true);
        this._el.nativeElement.appendChild(clone);
      }
    }, 1);
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/fake-ui-loader/fake-ui-loader.component.ts